import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EndoDiagnosisDataModel } from 'src/app/modules/forms/custom/diagnosis/models/endo-diagnosis-data.model';
import { SurgicalDiagnosisModel } from 'src/app/models/forms/Surgical/surgicalDiagnosis.model';
import { SurgicalTreatmentModel } from 'src/app/models/forms/Surgical/surgicalTreatment.model';
// Import or define your models as needed
// import { SurgicalDiagnosisConfigurationModel } from 'src/app/models/...';
// import { SurgicalDiagnosisPriorTreatmentDataModel } from 'src/app/models/...';

@Injectable({
  providedIn: 'root'
})
export class SurgicalService {
  constructor(private readonly http: HttpClient) {}

  saveConfig(model: any): Observable<any> {
    return this.http.post<any>(`api/surgical/save-surgical-config`, model);
  }

  getPriorTreatments(surgicalDiagId: string): Observable<any[]> {
    return this.http.get<any[]>(`api/surgical/get-surgical-prior-treatments/${surgicalDiagId}`);
  }

  savePriorTreatments(model: any): Observable<any> {
    return this.http.post<any>(`api/surgical/save-surgical-prior-treatment`, model);
  }

  deletePriorTreatments(model: any): Observable<any> {
    return this.http.post<any>(`api/surgical/delete-surgical-prior-treatment`, model);
  }

  saveSurgicalDiagnosis(model: SurgicalDiagnosisModel) {
    return this.http.post<SurgicalDiagnosisModel>(`api/surgical/save-surgical-diagnosis`, model);
  }

  saveDiagnosis(model: EndoDiagnosisDataModel) {
    return this.http.post<EndoDiagnosisDataModel>(`api/diagnosis/save-diagnosis-form`, model);
  }

  getSurgicalDiagnosisForm(patientId: string, caseWorkItemFormsId: string): Observable<SurgicalDiagnosisModel> {
    return this.http.get<SurgicalDiagnosisModel>(`api/surgical/get-surgical-diagnosis-form/${patientId}/${caseWorkItemFormsId}`);
  }

  getMTIProbings(patientId: string, MTEToothID: string): Observable<any> {
    return this.http.get<any>(`api/surgical/get-mti-probings/${patientId}/${MTEToothID}`);
  }

  saveSurgicalTreatment(model: SurgicalTreatmentModel) {
    return this.http.post<SurgicalTreatmentModel>(`api/surgical/save-surgical-treatment`, model);
  }

  getSurgicalTreatmentForm(patientId: string, caseWorkItemFormsId: string): Observable<SurgicalTreatmentModel> {
    return this.http.get<SurgicalTreatmentModel>(`api/surgical/get-surgical-treatment-form/${patientId}/${caseWorkItemFormsId}`);
  }
} 